import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { filter } from 'lodash-es';

import { CampaignStatus } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '@/store';

export const useCampaignStatuses = () => {
    const { t } = useTranslation();
    const {
        campaigns: { statusCount },
    } = useSelector((state: ApplicationState) => state);

    const possibleStatuses = [
        {
            label: t('active'),
            value: CampaignStatus.Active,
            count: statusCount?.active,
        },
        {
            label: t('paused'),
            value: CampaignStatus.Paused,
            count: statusCount?.paused,
        },
    ];
    return filter(possibleStatuses, (status): boolean => status.count > 0);
};
